import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  HeadlineAssetCollection,
} from '@bingads-webui-campaign-react/pmax-text-input';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PANEL_KEYS } from './panel-keys';

export const ShortHeadlinesPanel = ({
  headlinesCardSummaryDetails,
  allAssetsExpand,
  icon,
  featureName,
  setAddNewShortHeadlinesCallback,
  isOptional,
  ...rest
}) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedPanel
      key={PANEL_KEYS.SHORT_HEADLINES}
      title={<TextTitle
        titleKey={_TL_('Short headlines')}
        icon={icon}
        iconAltText={i18n.getString(_TL_('Short headlines'))}
        details={headlinesCardSummaryDetails}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand: allAssetsExpand,
        expandKey: PANEL_KEYS.SHORT_HEADLINES,
      }}
      {...rest}
    >
      <HeadlineAssetCollection featureName={featureName} showDeleteButton setAddNewShortHeadlinesCallback={setAddNewShortHeadlinesCallback} isOptional={isOptional} />
    </ValidatedPanel>
  );
};

ShortHeadlinesPanel.propTypes = {
  headlinesCardSummaryDetails: PropTypes.shape({}).isRequired,
  allAssetsExpand: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  setAddNewShortHeadlinesCallback: PropTypes.func.isRequired,
  featureName: PropTypes.string.isRequired,
  isOptional: PropTypes.bool,
};

ShortHeadlinesPanel.defaultProps = {
  isOptional: false,
};
